const styles: any = () => ({
  root: {
    ['&:first-child' as any]: {
      paddingTop: 0,
    },
  },
  content: {},
  contentText: {
    marginBottom: 0,
  },
  actions: {},
  noPadding: {
    padding: 0,
  },
  titleContainer: {},
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
});

export default styles;
